import { render, staticRenderFns } from "./metemails.vue?vue&type=template&id=54136fef&scoped=true"
import script from "./metemails.vue?vue&type=script&lang=js"
export * from "./metemails.vue?vue&type=script&lang=js"
import style0 from "./metemails.vue?vue&type=style&index=0&id=54136fef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54136fef",
  null
  
)

export default component.exports